import React from 'react';

import { observer } from 'mobx-react';

export interface IProps {
  open?: boolean;
  description: string;

  onClick: () => void;
}

const DescriptionNested: React.FC<IProps> = observer(({ open, description, onClick }) => {
  const className = React.useMemo(() => {
    return ['fa', !!open ? 'fa-chevron-down' : 'fa-chevron-right'].join(' ');
  }, [open]);

  return (
    <>
      <div className="flex-none cursor-pointer">
        <div className="w-5">
          <i className={className} onClick={onClick} />
        </div>
      </div>
      <div className="flex-both cursor-pointer" onClick={onClick}>
        {description}
      </div>
    </>
  );
});

DescriptionNested.displayName = 'DescriptionNested';

export default DescriptionNested;
